// App.js
import React from 'react';
import { AppBar, Toolbar, Typography, IconButton, Box, Button } from '@mui/material';
import { Link, Routes, Route } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu';
import Landing from './Pages/Landing/Landing';
import Login from './Pages/Login/Login';

function App() {
    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="white" aria-label="menu" sx={{ mr: 2 }}>
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ flexGrow: 1, color:'text.secondary' }}>
                        Massarius API
                    </Typography>
                    <Button color="white" component={Link} to="/login" sx={{ marginRight: 0}}>
                        Login
                    </Button>
                </Toolbar>
            </AppBar>
            <Routes>
                <Route path="/adtech" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="blogs" element={<div>Blogs</div>} />
                <Route path="contact" element={<div>Contact</div>} />
                <Route path="*" element={<div>Not Found</div>} />
            </Routes>
        </Box>
    );
}

export default App;
